import ActionType from "../../../isp._comun/iu/reductores/ActionType";
export default class ActionTypeCliente extends ActionType {}
